import { KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers'
import { TextField } from '@material-ui/core'
import React from 'react'
import { isValid } from 'date-fns'

export const DatePickerFilter = ({ column, handleFilterChanged, filter }) => {
  const handleChange = value => {
    const parsedValue = isValid(value) ? value.toISOString() : null
    handleFilterChanged({ columnName: column.name, value: parsedValue })
  }
  
  return (
    <KeyboardDatePicker
      style={{ margin: 2, marginBottom: 4 }}
      value={filter ? filter.value : null}
      format="MM/dd/yyyy"
      onChange={handleChange}
      InputAdornmentProps={{ position: 'start', style: { marginRight: 0 } }}
      KeyboardButtonProps={{ style: { padding: 2 } }}
      renderInput={(props) => <TextField {...props} helperText={null}/>}
    />
  )
}

export const DateTimePickerFilter = ({ column, handleFilterChanged, filter }) => {
  const handleChange = value => {
    const parsedValue = isValid(value) ? value.toISOString() : null
    handleFilterChanged({ columnName: column.name, value: parsedValue })
  }
  
  return (
    <KeyboardDateTimePicker
      style={{ margin: 2, marginBottom: 4 }}
      value={filter ? filter.value : null}
      format="MM/dd/yyyy HH:mm aa"
      onChange={handleChange}
      InputAdornmentProps={{ position: 'start', style: { marginRight: 0 } }}
      KeyboardButtonProps={{ style: { padding: 2 } }}
      renderInput={(props) => <TextField {...props} helperText={null}/>}
    />
  )
}